import { AxiosRequestConfig } from 'axios';
import api from './auth';
import { ApiLog, ApiLogQueryParams, ApiLogStatistics, PaginatedResponse } from '../types/api';

// 重新导出类型，保持向后兼容
export type { ApiLog, ApiLogQueryParams, ApiLogStatistics };

// 获取API日志列表（可选 axios 配置，如单独加大 timeout：日志表大时默认 10s 易超时）
export const getApiLogs = (
  params: ApiLogQueryParams = {},
  axiosConfig?: Omit<AxiosRequestConfig, 'params'>,
) => {
  return api.get<PaginatedResponse<ApiLog>>('/api-logs', { ...axiosConfig, params });
};

// 获取API日志统计信息
export const getApiLogStatistics = (startDate?: string, endDate?: string) => {
  const params: any = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return api.get<ApiLogStatistics>('/api-logs/statistics', { params });
};

// 获取API日志详情
export const getApiLogDetail = (id: number) => {
  return api.get<ApiLog>(`/api-logs/${id}`);
};

// 清理旧日志
export const cleanupApiLogs = (days: number = 30) => {
  return api.delete<{ message: string; deletedCount: number }>(`/api-logs/cleanup?days=${days}`, {
    validateStatus: (status) => status === 200 || status < 500 // 接受200状态码
  });
};
